import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { PartnerService } from '../../crud-service';
import { ContractTemplateDialogComponent } from './contract-template-dialog/contract-template-dialog.component';

@Component({
    selector: 'app-partner-settings',
    templateUrl: './partner-settings.component.html',
    styleUrls: ['./partner-settings.component.sass'],
})
export class PartnerSettingsComponent implements OnInit {
    templates: any = null;
    loading = false;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<PartnerSettingsComponent>,
        private dialog: MatDialog,
        private toastService: ToastService,
        private partnerService: PartnerService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.loadTemplates();
    }

    loadTemplates() {
        this.loading = true;
        this.partnerService.getContractTemplate().subscribe(
            (response) => {
                this.templates = response;
                this.loading = false;
            },
            (error) => {
                console.error('Erro ao carregar templates:', error);
                this.toastService.showError('Erro ao carregar templates. Tente novamente.');
                this.loading = false;
            }
        );
    }

    public openContractTemplateDialog(): void {
        GlobalUtils.openDialog({
            dialog: this.dialog,
            component: ContractTemplateDialogComponent,
            data: { templates: this.templates },
            dialogConfig: {
                width: '900px',
                height: '90vh',
                maxHeight: '90vh',
                disableClose: false
            },
            callBack: (result: any) => {
                if (result) {
                    this.loadTemplates();
                }
            },
        });
    }

    onCancel() {
        this.dialogRef.close();
    }
} 